import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import FlashlightText from "./components/FlashlightText";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div>
      <FlashlightText />
      <HomePage />
    </div> 
)
};

export default App;
